import token from "styled-token";
import { addSuffix } from "../util/addSuffix";
/** @mixin suffixMixin */

/**
 * Adds a suffix to the given value based on the `defaultUnit` token.
 *
 * @example
 * import { suffixMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     font-size: ${suffixMixin(3)};
 * `;
 *
 * <Component>3px font size</Component>
 *
 * @method
 * @param value - The value to add a suffix to.
 * @param {function} [callback] - An optional callback that will be called with an object with the
 *     value and suffix properties. The value returned from the function will be inserted.
 * @return {Interpolation}
 */

export var suffixMixin = function suffixMixin(value, callback) {
  return token("defaultUnit", function (suffix) {
    if (typeof callback === "function") {
      return callback({
        value: value,
        suffix: suffix
      });
    }

    return addSuffix(value, suffix);
  });
};